import React from "react";
import { css } from "@linaria/core";
import { colors, spacings } from "@ui/Theme";
import { radius } from "@ui";
import classNames from "classnames";

const WidgetCard = ({ children, className }: { children: React.ReactNode; className?: string }) => (
  <div className={classNames(widgetCard, className)}>{children}</div>
);
export default WidgetCard;

//#region CSS
const widgetCard = css`
  display: flex;
  flex-direction: column;
  padding: ${spacings.m};
  border-radius: ${radius};
  border: 1px solid ${colors.titanium200};
  color: ${colors.carbon800};
  background: ${colors.hydrogen};
  height: 100%;
`;
//#endregion CSS
